import React from 'react';
import { Box, Stack, SxProps, Theme } from '@mui/material';

type PageHeaderProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * En-tête de page empilé sur mobile (titre puis CTA full-width).
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, sx }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={2}
    justifyContent="space-between"
    alignItems={{ xs: 'stretch', sm: 'center' }}
    mb={3}
    sx={sx}
  >
    <Box minWidth={0}>
      {title}
      {subtitle}
    </Box>
    {actions ? (
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        gap={1.5}
        flexShrink={0}
        sx={{
          '& > .MuiButton-root': { width: { xs: '100%', sm: 'auto' } },
          '& > .MuiToggleButtonGroup-root': { alignSelf: { xs: 'stretch', sm: 'auto' } },
        }}
      >
        {actions}
      </Box>
    ) : null}
  </Stack>
);

export default PageHeader;
